import React from "react";
import { Card, Spinner } from "@shopify/polaris";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import lmsAPI from "../../services/lmsAPI";

export default function CardGraph(props) {
  const { t } = useTranslation();
  const { url, dataKey, dashboardParams, title, height, chart: Chart } = props;

  const { data, isError, isFetching } = useQuery(
    ["analytics", dataKey, dashboardParams],
    () => fetchData(dashboardParams)
  );

  async function fetchData(params) {
    const res = await lmsAPI.get(url, { params: params });
    return res.data;
  }

  return (
    <Card sectioned title={title}>
      <div style={{ height: height }}>
        {isError && <p>{t("common.error")}</p>}
        {isFetching && (
          <div
            style={{
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner size="large" />
          </div>
        )}
        {data && !isFetching && (
          <props.chart
            theme="Light"
            data={data}
            isAnimated
            showLegend
            // xAxisOptions={{ labels: Object.keys(data[0]) }}
          />
        )}
      </div>
    </Card>
  );
}
